'use client'
import ErrorBoundary from "@/plugins/bugsnag";

const ClientErrorBoundary = ({children}) => {
  return(
    <ErrorBoundary>
      {children}
    </ErrorBoundary>
  )
}

export default ClientErrorBoundary
